import { TextField } from '@qbe/ads-core';
import React from 'react';
import { Control, Controller } from 'react-hook-form';

import FormSpacer from '~/components-ds/FormSpacer';
import { useAppContent } from '~/hooks';
import { partialController } from '~/types/react-hook-form-helper';

interface PartialForm {
  firstName: string;
  lastName: string;
}

interface NameProps<T extends PartialForm> {
  control: Control<T>;
}

const maxLength = 30;
const alphabetsSpacesHyphens = /^[a-z\s-]+$/i;
const nameValidations = { pattern: alphabetsSpacesHyphens, required: true, maxLength };

const Name = <T extends PartialForm>({ control }: NameProps<T>) => {
  const partialControl = partialController<PartialForm, T>(control);

  const { getTextContent } = useAppContent({
    basePath: 'dsme.nameComponent.fields',
  });
  return (
    <>
      <Controller
        control={partialControl}
        name="firstName"
        render={({ field: { ref, ...field }, fieldState }) => (
          <TextField
            {...field}
            id="firstName"
            inputRef={ref}
            label={getTextContent('firstName.label')}
            data-track="First name"
            data-track-value="mask"
            helperText={
              fieldState.invalid
                ? getTextContent('firstName.invalidText')
                : getTextContent('firstName.helperText')
            }
            error={fieldState.invalid}
            displayIcon
            required
          />
        )}
        rules={nameValidations}
      />
      <FormSpacer variant="input" />

      <Controller
        control={partialControl}
        name="lastName"
        render={({ field: { ref, ...field }, fieldState }) => (
          <TextField
            {...field}
            id="lastName"
            inputRef={ref}
            label={getTextContent('lastName.label')}
            data-track="Last name"
            data-track-value="mask"
            error={fieldState.invalid}
            displayIcon
            helperText={
              fieldState.invalid
                ? getTextContent('lastName.invalidText')
                : getTextContent('lastName.helperText')
            }
            required
          />
        )}
        rules={nameValidations}
      />
    </>
  );
};

export default Name;
